<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="1280">
    <v-card>
        <v-toolbar  dense  elevation="0">
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{state=='new'?'Create':'Modify'}} User </span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="6">
                  <v-row>
                      <v-col cols="6">
                         <div ><v-icon small left >mdi-account</v-icon>Information</div>
                         <v-divider class="mb-4 mt-2"/>
                            <v-text-field
                          v-model="user.fullname"
                            label="Full Name *"
                            outlined
                            dense
                            :rules="textRules"
                          required
                          ></v-text-field>
                          <v-autocomplete
                          v-model="user.type"
                          item-text="name"   
                          :rules="textRules"
                        required
                          :items="user_types"
                          outlined
                            dense
                          label="Type"
                          ></v-autocomplete>
                                  <v-autocomplete
                          v-model="user.role"
                          item-text="name"   
                          :rules="textRules"
                        required
                          :items="roles"
                          outlined
                            dense
                          label="Role"
                          ></v-autocomplete>
                           <v-text-field
                            v-model="user.contact_no"
                              label="Contact No."
                              outlined
                              dense
                              :rules="textRules"
                            required
                          ></v-text-field> 
                           <v-text-field
                            v-model="user.email"
                              label="Email"
                              outlined
                              dense
                              :rules="textRules"
                            required
                          ></v-text-field> 
                         
                            <v-switch
                            v-model="user.status"
                            value="Active"
                            color="success"
                              inset
                                label="Status"
                          ></v-switch>
                          
                         
                      </v-col>
                        <v-col cols="6">
                           <div ><v-icon small left >mdi-key</v-icon>Login Credentials</div>
                          <v-divider class="mb-4 mt-2"/>

                          <v-text-field
                            outlined
                              dense
                            v-model="user.username"
                              label="Username *"
                              :rules="textRules"
                            required
                            ></v-text-field>

                            <v-text-field
                              v-model="user.password"
                              type="password"
                              v-if="state == 'new'"
                              label="Password *"
                              :rules="textRules"
                            required
                            outlined
                            hide-details
                              dense
                            ></v-text-field>
                          <v-text-field
                              v-model="newpassword"
                              v-if="changepass"
                              type="password"
                              label="Enter New Password"
                              :rules="textRules"
                               append-outer-icon="mdi-key-change"
                               @click:append-outer = "ChangePassword()"
                            required
                            outlined
                            hide-details
                              dense
                            ></v-text-field>

                            <span class="text-info def-font _link" @click="changepass=true"   v-if="state != 'new'">Change password</span>
                            <div class="mt-8 mb-2">
                              <div ><v-icon small left  @click="s3upload = true" >mdi-image</v-icon>Picture</div>
                          <v-divider class="mb-1 mt-2"/>
                              
                                  <img
                                    width="80%"
                                   @click="s3upload = true" class="imgsrc"
                                  v-if="user.profile != undefined && user.profile.picture  != undefined "
                                  :src="user.profile.picture"
                                  >
                                   <img v-else :src="$store.state.imgholder"  @click="s3upload = true" class="imgsrc"   width="90%" />
                               
                               <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
                             </div>
                              <p>
                            Date Registered: {{$moment(this.user.created).format("MMM DD, YYYY")}}
                            <br/>
                            Last Login: {{$moment(this.user.last_login).format("MMM DD, YYYY hh:mm A")}}
                          </p>
                           
                        </v-col>
                  </v-row>
             
               
               
                 
                  
                   
                 
                </v-col>
                <v-col cols="6">
                  Page Permissions
                  <v-divider></v-divider>
                  <v-row dense class="mb-10">
                    <v-col cols="6"  v-for="(action, index) in $store.state.page_permissions"  :key="index + '-page'">
                          <v-checkbox
                            hide-details
                            multiple
                            dense
                            v-model="user.page_permissions"
                            :label="action.description"
                            :value="action.page"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                      
                  <strong>Allow Action Permissions</strong>
                  <v-divider></v-divider>
                    <v-row dense>
                      <v-col cols="6"  v-for="(action, index) in $store.state.action_permissions"  :key="index + '-action'">
                          <v-checkbox
                            hide-details
                            multiple
                            dense
                            v-model="user.action_permissions"
                            :label="action.description"
                            :value="action.action"
                      ></v-checkbox>
                     
                      </v-col> 
                    </v-row> 
              
                </v-col>
              </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    data: {
        type: Object,
        default:()=>{}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      newpassword:'',
      changepass: false,
      s3upload: false,
      user:{},
      profile:{picture:"",address:""},
      experience:[],
      education:[],
      roles:[],
      user_types:[],
      show1: false,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      
  },
  watch: {
    show (v) {
      this.roles = this.GET_SYSVARS('user_roles')
      this.user_types = this.GET_SYSVARS('user_types')
      this.changepass = false
      if (v) {
         this.s3upload = true
       
         this.user = {}
       this.user.profile= {picture:"",address:""}
        if(this.state == 'modify') {
            this.user = this.data
            this.user.password ='********'
             this.profile = this.user.profile
            this.s3upload = false
        } else {
           this.$refs.form.reset()
        }
        
      } else {
      this.newpassword = ''
      this.user.profile = {picture:"",address:""}
        this.show1=false
        this.s3upload = false
         
        
      }
    }
  },
  methods: {
    s3Ev(e){
      if(e) {
        this.profile.picture = e[0]
        console.log(this.profile.picture)
        this.user.profile = this.profile
        this.s3upload = false
      }
      
    },
      validate () {
         this.user.profile = this.profile
         if(this.user.status != 'Active') {
          this.user.status = "Deactivated"
         }
        if (this.$refs.form.validate()) {
          this.show1 = false
          if(this.state=='new') {
              this.Create()
            } else {
              this.Update()
            }
        }
      },

      Create(){
         
           this.$http.post("new_user", this.user).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          console.log(e.data)
        })
    },
      Update(){
         
           this.$http.post("update_user", this.user).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          console.log(e.data)
        })
    },
    ChangePassword() {
      if( this.newpassword == '') {
        this.VA_ALERT('error', 'Please enter your new password!',"close", 500, 2000)
        return
      }
          this.$http.post("update_password", {id: this.user.id, password: this.newpassword}).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
             this.changepass = false

          }
        }).catch(e => {
          console.log(e.data) 
        })
     },
    emitToParent (action) {
      if(this.show1) {
        this.user.password = this.newpassword
      }
      console.log(this.user)
      this.$emit('DialogEvent', {action: action, user:this.user})
    }

  }
}
</script>
